import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  standalone: true
})
export class TooltipComponent {
  @Input() text: string;

  isShow = false;

  show() {
    this.isShow = true;
  }
}